import React, { Component } from "react";
import { Col } from "reactstrap";

class SearchItem extends Component {
  componentWillMount = () => {};

  render() {
    return <Col sm={12}>{this.props.data.titulli}</Col>;
  }
}
export default SearchItem;
